export enum ReservationSource {
    Web = 'web',
    MobileApp = 'mobileApp',
}

export enum ReservationSubSource {
    Seznam = 'seznam',
    Google = 'google',
}

export enum ReservationIipClientStatus {
    Waiting = 'waiting',
    Confirmed = 'confirmed',
    Rejected = 'rejected',
    Canceled = 'canceled',
}
